// https://cdn.simplelocalize.io/public/v1/locales
export const LOCALES_MAPPING = [
	{'locale':'aa-ER','language':'Afar','country':'Eritrea'},
	{'locale':'af-NA','language':'Afrikaans','country':'Namibia'},
	{'locale':'am-ET','language':'Amharic','country':'Ethiopia'},
	{'locale':'af-ZA','language':'Afrikaans','country':'South Africa'},
	{'locale':'ar-EG','language':'Arabic','country':'Egypt'},
	{'locale':'ar-DZ','language':'Arabic','country':'Algeria'},
	{'locale':'ar-BH','language':'Arabic','country':'Bahrain'},
	{'locale':'ar-DJ','language':'Arabic','country':'Djibouti'},
	{'locale':'ar-ER','language':'Arabic','country':'Eritrea'},
	{'locale':'ar-YE','language':'Arabic','country':'Yemen'},
	{'locale':'ar-IL','language':'Arabic','country':'Israel'},
	{'locale':'ar-IQ','language':'Arabic','country':'Iraq'},
	{'locale':'ar-JO','language':'Arabic','country':'Jordan'},
	{'locale':'ar-KM','language':'Arabic','country':'Comoros'},
	{'locale':'ar-QA','language':'Arabic','country':'Qatar'},
	{'locale':'ar-LB','language':'Arabic','country':'Lebanon'},
	{'locale':'ar-KW','language':'Arabic','country':'Kuwait'},
	{'locale':'ar-LY','language':'Arabic','country':'Libya'},
	{'locale':'ar-MA','language':'Arabic','country':'Morocco'},
	{'locale':'ar-MR','language':'Arabic','country':'Mauritania'},
	{'locale':'ar-PS','language':'Arabic','country':'Palestine'},
	{'locale':'ar-OM','language':'Arabic','country':'Oman'},
	{'locale':'ar-SA','language':'Arabic','country':'Saudi Arabia'},
	{'locale':'ar-SO','language':'Arabic','country':'Somalia'},
	{'locale':'ar-SD','language':'Arabic','country':'Sudan'},
	{'locale':'ar-SY','language':'Arabic','country':'Syria'},
	{'locale':'ar-TD','language':'Arabic','country':'Chad'},
	{'locale':'ar-TN','language':'Arabic','country':'Tunisia'},
	{'locale':'az-AZ','language':'Azerbaijani','country':'Azerbaijan'},
	{'locale':'ar-AE','language':'Arabic','country':'United Arab Emirates'},
	{'locale':'ay-BO','language':'Aymara','country':'Bolivia'},
	{'locale':'be-BY','language':'Belarusian','country':'Belarus'},
	{'locale':'bi-VU','language':'Bislama','country':'Vanuatu'},
	{'locale':'bn-BD','language':'Bengali','country':'Bangladesh'},
	{'locale':'bs-BA','language':'Bosnian','country':'Bosnia and Herzegovina'},
	{'locale':'bs-ME','language':'Bosnian','country':'Montenegro'},
	{'locale':'bg-BG','language':'Bulgarian','country':'Bulgaria'},
	{'locale':'ca-AD','language':'Catalan','country':'Andorra'},
	{'locale':'byn-ER','language':'Bilen','country':'Eritrea'},
	{'locale':'cs-CZ','language':'Czech','country':'Czechia'},
	{'locale':'ch-GU','language':'Chamorro','country':'Guam'},
	{'locale':'ch-MP','language':'Chamorro','country':'Northern Mariana Islands'},
	{'locale':'de-BE','language':'German','country':'Belgium'},
	{'locale':'da-DK','language':'Danish','country':'Denmark'},
	{'locale':'de-LI','language':'German','country':'Liechtenstein'},
	{'locale':'de-DE','language':'German','country':'Germany'},
	{'locale':'de-LU','language':'German','country':'Luxembourg'},
	{'locale':'de-AT','language':'German','country':'Austria'},
	{'locale':'de-CH','language':'German','country':'Switzerland'},
	{'locale':'de-VA','language':'German','country':'Vatican City'},
	{'locale':'dz-BT','language':'Dzongkha','country':'Bhutan'},
	{'locale':'el-GR','language':'Greek (modern)','country':'Greece'},
	{'locale':'dv-MV','language':'Divehi','country':'Maldives'},
	{'locale':'el-CY','language':'Greek (modern)','country':'Cyprus'},
	{'locale':'en-AS','language':'English','country':'American Samoa'},
	{'locale':'en-AI','language':'English','country':'Anguilla'},
	{'locale':'en-AQ','language':'English','country':'Antarctica'},
	{'locale':'en-AG','language':'English','country':'Antigua and Barbuda'},
	{'locale':'en-AU','language':'English','country':'Australia'},
	{'locale':'en-BS','language':'English','country':'Bahamas'},
	{'locale':'en-BB','language':'English','country':'Barbados'},
	{'locale':'en-BZ','language':'English','country':'Belize'},
	{'locale':'en-BM','language':'English','country':'Bermuda'},
	{'locale':'en-BW','language':'English','country':'Botswana'},
	{'locale':'en-IO','language':'English','country':'British Indian Ocean Territory'},
	{'locale':'en-CK','language':'English','country':'Cook Islands'},
	{'locale':'en-DM','language':'English','country':'Dominica'},
	{'locale':'en-CW','language':'English','country':'Curacao'},
	{'locale':'en-SZ','language':'English','country':'Eswatini'},
	{'locale':'en-FK','language':'English','country':'Falkland Islands'},
	{'locale':'en-FJ','language':'English','country':'Fiji'},
	{'locale':'en-ER','language':'English','country':'Eritrea'},
	{'locale':'en-FM','language':'English','country':'Federated States of Micronesia'},
	{'locale':'en-GM','language':'English','country':'Gambia'},
	{'locale':'en-GI','language':'English','country':'Gibraltar'},
	{'locale':'en-GH','language':'English','country':'Ghana'},
	{'locale':'en-GD','language':'English','country':'Grenada'},
	{'locale':'en-GG','language':'English','country':'Guernsey'},
	{'locale':'en-GY','language':'English','country':'Guyana'},
	{'locale':'en-GU','language':'English','country':'Guam'},
	{'locale':'en-HM','language':'English','country':'Heard Island and McDonald Islands'},
	{'locale':'en-IM','language':'English','country':'Isle of Man'},
	{'locale':'en-IE','language':'English','country':'Ireland'},
	{'locale':'en-HK','language':'English','country':'Hong Kong'},
	{'locale':'en-JM','language':'English','country':'Jamaica'},
	{'locale':'en-JE','language':'English','country':'Jersey'},
	{'locale':'en-IN','language':'English','country':'India'},
	{'locale':'en-VG','language':'English','country':'British Virgin Islands'},
	{'locale':'en-VI','language':'English','country':'Virgin Islands'},
	{'locale':'en-CM','language':'English','country':'Cameroon'},
	{'locale':'en-CA','language':'English','country':'Canada'},
	{'locale':'en-KE','language':'English','country':'Kenya'},
	{'locale':'en-KI','language':'English','country':'Kiribati'},
	{'locale':'en-UM','language':'English','country':'United States Minor Outlying Islands'},
	{'locale':'en-CC','language':'English','country':'Cocos (Keeling) Islands'},
	{'locale':'en-KY','language':'English','country':'Cayman Islands'},
	{'locale':'en-LR','language':'English','country':'Liberia'},
	{'locale':'en-LS','language':'English','country':'Lesotho'},
	{'locale':'en-MT','language':'English','country':'Malta'},
	{'locale':'en-MH','language':'English','country':'Marshall Islands'},
	{'locale':'en-MU','language':'English','country':'Mauritius'},
	{'locale':'en-MS','language':'English','country':'Montserrat'},
	{'locale':'en-NA','language':'English','country':'Namibia'},
	{'locale':'en-NR','language':'English','country':'Nauru'},
	{'locale':'en-NZ','language':'English','country':'New Zealand'},
	{'locale':'en-NG','language':'English','country':'Nigeria'},
	{'locale':'en-NU','language':'English','country':'Niue'},
	{'locale':'en-MP','language':'English','country':'Northern Mariana Islands'},
	{'locale':'en-NF','language':'English','country':'Norfolk Island'},
	{'locale':'en-PW','language':'English','country':'Palau'},
	{'locale':'en-PK','language':'English','country':'Pakistan'},
	{'locale':'en-PG','language':'English','country':'Papua New Guinea'},
	{'locale':'en-MW','language':'English','country':'Malawi'},
	{'locale':'en-PH','language':'English','country':'Philippines'},
	{'locale':'en-PN','language':'English','country':'Pitcairn Islands'},
	{'locale':'en-PR','language':'English','country':'Puerto Rico'},
	{'locale':'en-RW','language':'English','country':'Rwanda'},
	{'locale':'en-MF','language':'English','country':'Saint Martin'},
	{'locale':'en-SB','language':'English','country':'Solomon Islands'},
	{'locale':'en-ZM','language':'English','country':'Zambia'},
	{'locale':'en-WS','language':'English','country':'Samoa'},
	{'locale':'en-SC','language':'English','country':'Seychelles'},
	{'locale':'en-SL','language':'English','country':'Sierra Leone'},
	{'locale':'en-SX','language':'English','country':'Sint Maarten'},
	{'locale':'en-ZW','language':'English','country':'Zimbabwe'},
	{'locale':'en-SG','language':'English','country':'Singapore'},
	{'locale':'en-SH','language':'English','country':'Saint Helena, Ascension and Tristan da Cunha'},
	{'locale':'en-KN','language':'English','country':'Saint Kitts and Nevis'},
	{'locale':'en-LC','language':'English','country':'Saint Lucia'},
	{'locale':'en-ZA','language':'English','country':'South Africa'},
	{'locale':'en-SD','language':'English','country':'Sudan'},
	{'locale':'en-GS','language':'English','country':'South Georgia and South Sandwich Islands'},
	{'locale':'en-SS','language':'English','country':'South Sudan'},
	{'locale':'en-TZ','language':'English','country':'Tanzania'},
	{'locale':'en-TK','language':'English','country':'Tokelau'},
	{'locale':'en-TO','language':'English','country':'Tonga'},
	{'locale':'en-TT','language':'English','country':'Trinidad and Tobago'},
	{'locale':'en-TC','language':'English','country':'Turks and Caicos Islands'},
	{'locale':'en-VC','language':'English','country':'Saint Vincent and the Grenadines'},
	{'locale':'en-VU','language':'English','country':'Vanuatu'},
	{'locale':'en-TV','language':'English','country':'Tuvalu'},
	{'locale':'en-UG','language':'English','country':'Uganda'},
	{'locale':'en-US','language':'English','country':'United States of America'},
	{'locale':'en-GB','language':'English','country':'United Kingdom'},
	{'locale':'en-CX','language':'English','country':'Christmas Island'},
	{'locale':'fan-GQ','language':'Fang','country':'Equatorial Guinea'},
	{'locale':'fo-FO','language':'Faroese','country':'Faroe Islands'},
	{'locale':'et-EE','language':'Estonian','country':'Estonia'},
	{'locale':'fa-IR','language':'Persian (Farsi)','country':'Iran'},
	{'locale':'fj-FJ','language':'Fijian','country':'Fiji'},
	{'locale':'fi-FI','language':'Finnish','country':'Finland'},
	{'locale':'fr-GQ','language':'French','country':'Equatorial Guinea'},
	{'locale':'fr-BJ','language':'French','country':'Benin'},
	{'locale':'fr-BE','language':'French','country':'Belgium'},
	{'locale':'fr-BF','language':'French','country':'Burkina Faso'},
	{'locale':'fr-CD','language':'French','country':'Democratic Republic of the Congo'},
	{'locale':'fr-BI','language':'French','country':'Burundi'},
	{'locale':'fr-DJ','language':'French','country':'Djibouti'},
	{'locale':'fr-CI','language':'French','country':'Ivory Coast'},
	{'locale':'fr-FR','language':'French','country':'France'},
	{'locale':'fr-GF','language':'French','country':'French Guiana'},
	{'locale':'fr-PF','language':'French','country':'French Polynesia'},
	{'locale':'fr-TF','language':'French','country':'French Southern and Antarctic Lands'},
	{'locale':'fr-GA','language':'French','country':'Gabon'},
	{'locale':'fr-GP','language':'French','country':'Guadeloupe'},
	{'locale':'fr-HT','language':'French','country':'Haiti'},
	{'locale':'fr-GN','language':'French','country':'Guinea'},
	{'locale':'fr-JE','language':'French','country':'Jersey'},
	{'locale':'fr-MC','language':'French','country':'Principality of Monaco'},
	{'locale':'fr-CA','language':'French','country':'Canada'},
	{'locale':'fr-GG','language':'French','country':'Guernsey'},
	{'locale':'fr-CM','language':'French','country':'Cameroon'},
	{'locale':'fr-KM','language':'French','country':'Comoros'},
	{'locale':'fr-LB','language':'French','country':'Lebanon'},
	{'locale':'fr-MG','language':'French','country':'Madagascar'},
	{'locale':'fr-LU','language':'French','country':'Luxembourg'},
	{'locale':'fr-MQ','language':'French','country':'Martinique'},
	{'locale':'fr-ML','language':'French','country':'Mali'},
	{'locale':'fr-YT','language':'French','country':'Mayotte'},
	{'locale':'fr-NC','language':'French','country':'New Caledonia'},
	{'locale':'fr-CG','language':'French','country':'Republic of the Congo'},
	{'locale':'fr-RE','language':'French','country':'Reunion'},
	{'locale':'fr-RW','language':'French','country':'Rwanda'},
	{'locale':'fr-MF','language':'French','country':'Saint Martin'},
	{'locale':'fr-BL','language':'French','country':'Saint Barthelemy'},
	{'locale':'fr-NE','language':'French','country':'Niger'},
	{'locale':'fr-CH','language':'French','country':'Switzerland'},
	{'locale':'fr-SC','language':'French','country':'Seychelles'},
	{'locale':'fr-PM','language':'French','country':'Saint Pierre and Miquelon'},
	{'locale':'fr-TG','language':'French','country':'Togo'},
	{'locale':'fr-SN','language':'French','country':'Senegal'},
	{'locale':'fr-TD','language':'French','country':'Chad'},
	{'locale':'fr-VA','language':'French','country':'Vatican City'},
	{'locale':'fr-VU','language':'French','country':'Vanuatu'},
	{'locale':'fr-WF','language':'French','country':'Wallis and Futuna'},
	{'locale':'fr-CF','language':'French','country':'Central African Republic'},
	{'locale':'ff-GN','language':'Fula','country':'Guinea'},
	{'locale':'ff-BF','language':'Fula','country':'Burkina Faso'},
	{'locale':'ga-IE','language':'Irish','country':'Ireland'},
	{'locale':'gv-IM','language':'Manx','country':'Isle of Man'},
	{'locale':'gn-AR','language':'Guaraní','country':'Argentina'},
	{'locale':'gn-PY','language':'Guaraní','country':'Paraguay'},
	{'locale':'ht-HT','language':'Haitian','country':'Haiti'},
	{'locale':'he-IL','language':'Hebrew (modern)','country':'Israel'},
	{'locale':'hif-FJ','language':'Fiji Hindi','country':'Fiji'},
	{'locale':'hr-BA','language':'Croatian','country':'Bosnia and Herzegovina'},
	{'locale':'hi-IN','language':'Hindi','country':'India'},
	{'locale':'hr-HR','language':'Croatian','country':'Croatia'},
	{'locale':'hr-ME','language':'Croatian','country':'Montenegro'},
	{'locale':'hu-HU','language':'Hungarian','country':'Hungary'},
	{'locale':'hy-AM','language':'Armenian','country':'Armenia'},
	{'locale':'id-ID','language':'Indonesian','country':'Indonesia'},
	{'locale':'is-IS','language':'Icelandic','country':'Iceland'},
	{'locale':'it-IT','language':'Italian','country':'Italy'},
	{'locale':'hy-CY','language':'Armenian','country':'Cyprus'},
	{'locale':'it-SM','language':'Italian','country':'San Marino'},
	{'locale':'it-CH','language':'Italian','country':'Switzerland'},
	{'locale':'it-VA','language':'Italian','country':'Vatican City'},
	{'locale':'kl-GL','language':'Greenlandic','country':'Greenland'},
	{'locale':'ja-JP','language':'Japanese','country':'Japan'},
	{'locale':'ka-GE','language':'Georgian','country':'Georgia'},
	{'locale':'kk-KZ','language':'Kazakh','country':'Kazakhstan'},
	{'locale':'km-KH','language':'Khmer','country':'Cambodia'},
	{'locale':'rw-RW','language':'Kinyarwanda','country':'Rwanda'},
	{'locale':'kg-CD','language':'Kongo','country':'Democratic Republic of the Congo'},
	{'locale':'ky-KG','language':'Kyrgyz','country':'Kyrgyzstan'},
	{'locale':'ko-KP','language':'Korean','country':'North Korea'},
	{'locale':'ko-KR','language':'Korean','country':'South Korea'},
	{'locale':'kun-ER','language':'Kunama','country':'Eritrea'},
	{'locale':'lo-LA','language':'Lao','country':'Laos'},
	{'locale':'ku-IQ','language':'Kurdish','country':'Iraq'},
	{'locale':'la-VA','language':'Latin','country':'Vatican City'},
	{'locale':'lv-LV','language':'Latvian','country':'Latvia'},
	{'locale':'ln-CG','language':'Lingala','country':'Republic of the Congo'},
	{'locale':'ln-CD','language':'Lingala','country':'Democratic Republic of the Congo'},
	{'locale':'lb-LU','language':'Luxembourgish','country':'Luxembourg'},
	{'locale':'lu-CD','language':'Luba-Katanga','country':'Democratic Republic of the Congo'},
	{'locale':'lt-LT','language':'Lithuanian','country':'Lithuania'},
	{'locale':'mk-MK','language':'Macedonian','country':'North Macedonia'},
	{'locale':'mh-MH','language':'Marshallese','country':'Marshall Islands'},
	{'locale':'mg-MG','language':'Malagasy','country':'Madagascar'},
	{'locale':'mn-MN','language':'Mongolian','country':'Mongolia'},
	{'locale':'mi-NZ','language':'Māori','country':'New Zealand'},
	{'locale':'mt-MT','language':'Maltese','country':'Malta'},
	{'locale':'ms-BN','language':'Malay','country':'Brunei'},
	{'locale':'ms-SG','language':'Malay','country':'Singapore'},
	{'locale':'my-MM','language':'Burmese','country':'Myanmar'},
	{'locale':'na-NR','language':'Nauruan','country':'Nauru'},
	{'locale':'nr-ZA','language':'Southern Ndebele','country':'South Africa'},
	{'locale':'nd-ZW','language':'Northern Ndebele','country':'Zimbabwe'},
	{'locale':'nl-AW','language':'Dutch','country':'Aruba'},
	{'locale':'ne-NP','language':'Nepali','country':'Nepal'},
	{'locale':'nl-BE','language':'Dutch','country':'Belgium'},
	{'locale':'nl-BQ','language':'Dutch','country':'Caribbean Netherlands'},
	{'locale':'nl-NL','language':'Dutch','country':'Netherlands'},
	{'locale':'nl-CW','language':'Dutch','country':'Curacao'},
	{'locale':'nl-MF','language':'Dutch','country':'Saint Martin'},
	{'locale':'nl-SX','language':'Dutch','country':'Sint Maarten'},
	{'locale':'nn-BV','language':'Norwegian Nynorsk','country':'Bouvet Island'},
	{'locale':'nl-SR','language':'Dutch','country':'Suriname'},
	{'locale':'nn-NO','language':'Norwegian Nynorsk','country':'Norway'},
	{'locale':'nb-BV','language':'Norwegian Bokmål','country':'Bouvet Island'},
	{'locale':'no-BV','language':'Norwegian','country':'Bouvet Island'},
	{'locale':'nb-NO','language':'Norwegian Bokmål','country':'Norway'},
	{'locale':'no-NO','language':'Norwegian','country':'Norway'},
	{'locale':'no-SJ','language':'Norwegian','country':'Svalbard'},
	{'locale':'pa-AW','language':'Punjabi (Eastern)','country':'Aruba'},
	{'locale':'nrb-ER','language':'Nara','country':'Eritrea'},
	{'locale':'ny-MW','language':'Chichewa','country':'Malawi'},
	{'locale':'pa-CW','language':'Punjabi (Eastern)','country':'Curacao'},
	{'locale':'pl-PL','language':'Polish','country':'Poland'},
	{'locale':'pt-AO','language':'Portuguese','country':'Angola'},
	{'locale':'pt-GQ','language':'Portuguese','country':'Equatorial Guinea'},
	{'locale':'pt-GW','language':'Portuguese','country':'Guinea-Bissau'},
	{'locale':'pt-BR','language':'Portuguese','country':'Brazil'},
	{'locale':'pt-CV','language':'Portuguese','country':'Cape Verde'},
	{'locale':'pt-MO','language':'Portuguese','country':'Macao'},
	{'locale':'pt-TL','language':'Portuguese','country':'East Timor'},
	{'locale':'pt-MZ','language':'Portuguese','country':'Mozambique'},
	{'locale':'pt-PT','language':'Portuguese','country':'Portugal'},
	{'locale':'pt-ST','language':'Portuguese','country':'Sao Tome and Principe'},
	{'locale':'qu-BO','language':'Quechua','country':'Bolivia'},
	{'locale':'ps-AF','language':'Pashto','country':'Afghanistan'},
	{'locale':'rar-CK','language':'Cook Islands Māori','country':'Cook Islands'},
	{'locale':'ro-MD','language':'Romanian','country':'Moldova'},
	{'locale':'rm-CH','language':'Romansh','country':'Switzerland'},
	{'locale':'rtm-FJ','language':'Rotuman','country':'Fiji'},
	{'locale':'rn-BI','language':'Kirundi','country':'Burundi'},
	{'locale':'ro-RO','language':'Romanian','country':'Romania'},
	{'locale':'ru-AQ','language':'Russian','country':'Antarctica'},
	{'locale':'ru-KZ','language':'Russian','country':'Kazakhstan'},
	{'locale':'ru-BY','language':'Russian','country':'Belarus'},
	{'locale':'ru-RU','language':'Russian','country':'Russia'},
	{'locale':'ru-KG','language':'Russian','country':'Kyrgyzstan'},
	{'locale':'ru-TM','language':'Russian','country':'Turkmenistan'},
	{'locale':'ru-UZ','language':'Russian','country':'Uzbekistan'},
	{'locale':'sg-CF','language':'Sango','country':'Central African Republic'},
	{'locale':'si-LK','language':'Sinhalese','country':'Sri Lanka'},
	{'locale':'sk-SK','language':'Slovak','country':'Slovakia'},
	{'locale':'sk-CZ','language':'Slovak','country':'Czechia'},
	{'locale':'sl-SI','language':'Slovene','country':'Slovenia'},
	{'locale':'sm-AS','language':'Samoan','country':'American Samoa'},
	{'locale':'sn-ZW','language':'Shona','country':'Zimbabwe'},
	{'locale':'ru-TJ','language':'Russian','country':'Tajikistan'},
	{'locale':'so-SO','language':'Somali','country':'Somalia'},
	{'locale':'st-LS','language':'Southern Sotho','country':'Lesotho'},
	{'locale':'st-ZA','language':'Southern Sotho','country':'South Africa'},
	{'locale':'es-GQ','language':'Spanish','country':'Equatorial Guinea'},
	{'locale':'es-AR','language':'Spanish','country':'Argentina'},
	{'locale':'sm-WS','language':'Samoan','country':'Samoa'},
	{'locale':'es-BO','language':'Spanish','country':'Bolivia'},
	{'locale':'es-CL','language':'Spanish','country':'Chile'},
	{'locale':'es-BZ','language':'Spanish','country':'Belize'},
	{'locale':'es-DO','language':'Spanish','country':'Dominican Republic'},
	{'locale':'es-CR','language':'Spanish','country':'Costa Rica'},
	{'locale':'es-SV','language':'Spanish','country':'El Salvador'},
	{'locale':'es-EC','language':'Spanish','country':'Ecuador'},
	{'locale':'es-GU','language':'Spanish','country':'Guam'},
	{'locale':'es-GT','language':'Spanish','country':'Guatemala'},
	{'locale':'es-CO','language':'Spanish','country':'Colombia'},
	{'locale':'es-MX','language':'Spanish','country':'Mexico'},
	{'locale':'es-CU','language':'Spanish','country':'Cuba'},
	{'locale':'es-HN','language':'Spanish','country':'Honduras'},
	{'locale':'es-NI','language':'Spanish','country':'Nicaragua'},
	{'locale':'es-PY','language':'Spanish','country':'Paraguay'},
	{'locale':'es-PA','language':'Spanish','country':'Panama'},
	{'locale':'es-PE','language':'Spanish','country':'Peru'},
	{'locale':'es-PR','language':'Spanish','country':'Puerto Rico'},
	{'locale':'es-VE','language':'Spanish','country':'Venezuela'},
	{'locale':'es-UY','language':'Spanish','country':'Uruguay'},
	{'locale':'es-EH','language':'Spanish','country':'Western Sahara'},
	{'locale':'es-ES','language':'Spanish','country':'Spain'},
	{'locale':'sq-AL','language':'Albanian','country':'Albania'},
	{'locale':'sq-XK','language':'Albanian','country':'Kosovo'},
	{'locale':'sr-BA','language':'Serbian','country':'Bosnia and Herzegovina'},
	{'locale':'sr-XK','language':'Serbian','country':'Kosovo'},
	{'locale':'sq-ME','language':'Albanian','country':'Montenegro'},
	{'locale':'sr-ME','language':'Serbian','country':'Montenegro'},
	{'locale':'sr-RS','language':'Serbian','country':'Serbia'},
	{'locale':'ss-SZ','language':'Swati','country':'Eswatini'},
	{'locale':'ss-ZA','language':'Swati','country':'South Africa'},
	{'locale':'sw-CD','language':'Swahili','country':'Democratic Republic of the Congo'},
	{'locale':'sw-KE','language':'Swahili','country':'Kenya'},
	{'locale':'sw-TZ','language':'Swahili','country':'Tanzania'},
	{'locale':'sw-UG','language':'Swahili','country':'Uganda'},
	{'locale':'ssy-ER','language':'Saho','country':'Eritrea'},
	{'locale':'sv-AX','language':'Swedish','country':'Åland Islands'},
	{'locale':'ta-SG','language':'Tamil','country':'Singapore'},
	{'locale':'sv-FI','language':'Swedish','country':'Finland'},
	{'locale':'sv-SE','language':'Swedish','country':'Sweden'},
	{'locale':'ta-LK','language':'Tamil','country':'Sri Lanka'},
	{'locale':'tg-TJ','language':'Tajik','country':'Tajikistan'},
	{'locale':'th-TH','language':'Thai','country':'Thailand'},
	{'locale':'ti-ER','language':'Tigrinya','country':'Eritrea'},
	{'locale':'to-TO','language':'Tonga (Tonga Islands)','country':'Tonga'},
	{'locale':'tn-ZA','language':'Tswana','country':'South Africa'},
	{'locale':'tn-BW','language':'Tswana','country':'Botswana'},
	{'locale':'tig-ER','language':'Tigre','country':'Eritrea'},
	{'locale':'ts-ZA','language':'Tsonga','country':'South Africa'},
	{'locale':'tk-AF','language':'Turkmen','country':'Afghanistan'},
	{'locale':'tk-TM','language':'Turkmen','country':'Turkmenistan'},
	{'locale':'tr-CY','language':'Turkish','country':'Cyprus'},
	{'locale':'uk-UA','language':'Ukrainian','country':'Ukraine'},
	{'locale':'ur-PK','language':'Urdu','country':'Pakistan'},
	{'locale':'tr-TR','language':'Turkish','country':'Turkey'},
	{'locale':'uz-AF','language':'Uzbek','country':'Afghanistan'},
	{'locale':'uz-UZ','language':'Uzbek','country':'Uzbekistan'},
	{'locale':'vi-VN','language':'Vietnamese','country':'Vietnam'},
	{'locale':'zh-CN','language':'Chinese','country':'China'},
	{'locale':'ve-ZA','language':'Venda','country':'South Africa'},
	{'locale':'xh-ZA','language':'Xhosa','country':'South Africa'},
	{'locale':'zh-HK','language':'Chinese','country':'Hong Kong'},
	{'locale':'zh-SG','language':'Chinese','country':'Singapore'},
	{'locale':'zh-TW','language':'Chinese','country':'Taiwan'},
	{'locale':'zh-MO','language':'Chinese','country':'Macao'},
	{'locale':'ms-MY','language':'Malay','country':'Malaysia'},
	{'locale':'zu-ZA','language':'Zulu','country':'South Africa'}
];


// WEBPACK FOOTER //
// ./src/utils/language.js